module.exports = __webpack_public_path__ + "img/3.C.edbe35fb.jpg";